<script setup>
import { computed, ref } from 'vue';
import { Languages, ChevronDown } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const open = ref(false);
const options = [
  { value: 'zh-CN', label: '简体中文' },
  { value: 'en', label: 'English' },
  { value: 'ja', label: '日本語' },
  { value: 'fr', label: 'Français' },
  { value: 'pt-BR', label: 'Português' }
];
const current = computed(() => options.find((item) => item.value === locale.value)?.label || 'Language');
const select = (value) => { locale.value = value; localStorage.setItem('u1card-locale', value); open.value = false; };
</script>

<template>
  <div class="language-switch">
    <button class="language-trigger" type="button" :aria-expanded="open" @click="open = !open"><Languages :size="15" /><span>{{ current }}</span><ChevronDown :size="13" /></button>
    <div v-if="open" class="language-menu">
      <button v-for="item in options" :key="item.value" type="button" :class="{ active: locale === item.value }" @click="select(item.value)">{{ item.label }}</button>
    </div>
  </div>
</template>

<style scoped>
.language-switch { position: relative; z-index: 40; }
.language-trigger { display: flex; align-items: center; gap: 6px; height: 34px; padding: 0 11px; border: 1px solid #34343c; border-radius: 11px; background: rgba(25,25,29,.82); color: #c8c8cd; font-size: 11px; cursor: pointer; backdrop-filter: blur(12px); transition: border-color .2s, background .2s; }
.language-trigger:hover { border-color: #4a4a54; background: #222228; }
.language-trigger span { max-width: 72px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.language-menu { position: absolute; top: 40px; right: 0; min-width: 138px; padding: 6px; border: 1px solid #37373f; border-radius: 13px; background: rgba(25,25,29,.98); box-shadow: 0 18px 38px rgba(0,0,0,.5); }
.language-menu button { width: 100%; height: 34px; padding: 0 10px; border: 0; border-radius: 8px; background: none; text-align: left; font-size: 12px; color: #bbb; cursor: pointer; }
.language-menu button:hover, .language-menu button.active { color: #fff; background: #5a45fe; }
</style>
